import { useTrackEventForAdoption } from "src/query/adoption";
import {
  PAGE_VIEWED,
  TRACK_SCREEN_VIEW_MANAGE_USER_ACCESS
} from "src/constants/adoption/eventTypes";

import _ from "lodash";
import { SettingsModule } from "src/types/settings/common";


export const useStreamAccessAdoption = () => {
  const { mutate: trackEvent } = useTrackEventForAdoption(SettingsModule.DASHBOARD);

  const screenProperty = {
    "screen_name": TRACK_SCREEN_VIEW_MANAGE_USER_ACCESS
  }

  const trackStreamAccessClicked = () => {
    const event = {
        event: PAGE_VIEWED,
        properties: screenProperty,
    };
    trackEvent(event);
  };

  return {
     trackStreamAccessClicked,
  };
};
